const SECONDES_PAR_JOUR = 24 * 3600;

/**
 * A duration in words for the waiting screen (#7): "14 s", "1 min 42 s", "2 min", "1 h 05 min",
 * and since #13 "moins d'une seconde" under a second (never "0 s") and days beyond 24 hours
 * ("3 jours", "1 jour 4 h", never "72 h"). Seconds only under an hour, minutes only under a day,
 * zero minutes, hours and seconds left out. A negative or missing duration reads as under a
 * second.
 */
export function formaterDuree(secondes: number): string {
  const total = Math.max(0, Math.floor(Number.isFinite(secondes) ? secondes : 0));
  if (total < 1) return "moins d'une seconde";
  if (total < 60) return `${total} s`;
  const minutes = Math.floor(total / 60);
  if (total < 3600) {
    const reste = total % 60;
    return reste === 0 ? `${minutes} min` : `${minutes} min ${reste} s`;
  }
  if (total < SECONDES_PAR_JOUR) {
    const heures = Math.floor(minutes / 60);
    const resteMinutes = minutes % 60;
    return resteMinutes === 0
      ? `${heures} h`
      : `${heures} h ${String(resteMinutes).padStart(2, '0')} min`;
  }
  const jours = Math.floor(total / SECONDES_PAR_JOUR);
  const heures = Math.floor((total % SECONDES_PAR_JOUR) / 3600);
  const motJours = `${jours} jour${jours > 1 ? 's' : ''}`;
  return heures === 0 ? motJours : `${motJours} ${heures} h`;
}

/** Under this many seconds a translation "began a moment ago" rather than "N s ago" (#13). */
const INSTANT_SECONDES = 10;

/**
 * When a translation began, as the waiting screen says it (B11, #13): "à l'instant" for the first
 * ten seconds (the screen is read every 5 s: "il y a 0 s" was the first thing a user saw), then
 * "il y a <durée>".
 */
export function formaterDepuis(secondes: number): string {
  return secondes < INSTANT_SECONDES ? "à l'instant" : `il y a ${formaterDuree(secondes)}`;
}
